import React from 'react';
import { Provider } from 'react-redux';
import { store } from './src/store';
import { AuthProvider } from './src/context/AuthContext';
import { GoogleOAuthProvider } from '@react-oauth/google';

const GOOGLE_CLIENT_ID = process.env.GATSBY_GOOGLE_CLIENT_ID;

// eslint-disable-next-line
export default ({ element }) => {
  return (
    <Provider store={store}>
      <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID as string}>
        <AuthProvider>{element}</AuthProvider>
      </GoogleOAuthProvider>
    </Provider>
  );
};
